// Operations — real system health: Company Health V1, System Pulse V1, and per-BU DB
// probes (/bu/health). Reuses the right-rail cards at full width.
import React from "react";
import { useBrainResource } from "../lib/hooks";
import { LoadingState, ErrorState, EmptyState } from "../BrainStates";
import HealthCard from "../panels/HealthCard";
import SystemPulseCard from "../panels/SystemPulseCard";

function BuHealth() {
  const bu = useBrainResource("/bu/health");
  if (bu.status === "loading") return <LoadingState label="Probing databases" />;
  if (bu.status === "error") return <ErrorState detail={bu.error && bu.error.message} onRetry={bu.reload} />;
  const rows = (bu.data && bu.data.business_units) || [];
  if (rows.length === 0) return <EmptyState title="No BU health data" testId="bu-health-empty" />;
  return (
    <div data-testid="bu-health" className="rounded-xl border border-slate-800 bg-slate-900/60 p-4">
      <h2 className="mb-3 text-sm font-semibold text-slate-200">Business-unit databases</h2>
      <ul className="space-y-2">
        {rows.map((r) => (
          <li key={r.bu} className="flex items-center justify-between text-sm text-slate-300" data-testid="bu-health-row">
            <span className="flex items-center gap-2"><span className={`h-2.5 w-2.5 rounded-full ${r.status === "green" ? "bg-emerald-400" : "bg-rose-400"}`} />{r.bu}</span>
            <span className="text-xs text-slate-500">{r.latency_ms != null ? `${r.latency_ms}ms` : "—"}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function OperationsScreen() {
  return (
    <div data-testid="operations-screen" className="space-y-5">
      <h1 className="text-2xl font-extrabold tracking-tight text-white">Operations</h1>
      <div className="grid gap-5 lg:grid-cols-3">
        <HealthCard />
        <SystemPulseCard />
        <BuHealth />
      </div>
    </div>
  );
}
